import {
  UserPermissionForStationState,
  UserPermissionSource,
  UserPermissionState,
  UserPermissionType,
} from '@app/modules/admin/types';
import { Group } from '@mi-front/core';

export function canUserTogglePermission(
  pState: UserPermissionState | UserPermissionForStationState,
): boolean {
  const { permission } = pState;

  if (permission === null) {
    return true;
  }

  if (permission.type === UserPermissionSource.FROM_ROLE) {
    return false;
  }

  return permission.type === UserPermissionSource.DIRECT;
}

export function getGroupFromPermission(permission: UserPermissionType | null): Group | null {
  if (!permission) {
    return null;
  }

  if (
    permission.type === UserPermissionSource.FROM_GROUP ||
    permission.type === UserPermissionSource.DIRECT_AND_FROM_GROUP
  ) {
    return permission.group;
  }

  return null;
}
